module.exports = __webpack_public_path__ + "static/media/13-kirurgi.733a472c.mp3";